module.exports = __webpack_public_path__ + "img/radarmeteo-logotipo.aa6fbfb0.png";